<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive exclude="RedirectPage">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { setWaterMark, removeWatermark } from '@/utils/waterMark';

export default {
  name: 'AppMain',
  data() {
    return {
      timeout: null
    };
  },
  computed: {
    key() {
      return this.$route.path;
    },
    ...mapGetters(['name'])
  },
  methods: {
    interValSetMark() {
      this.timeout = setTimeout(() => {
        setWaterMark(this.name);
        clearTimeout(this.timeout);
        this.interValSetMark();
      }, 60000);
    }
  },
  mounted() {
    // setWaterMark(this.name);
    // this.interValSetMark();
  },
  beforeDestroy() {
    removeWatermark();
    clearTimeout(this.timeout);
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  // navbar 60px, tags-view 48px
  height: calc(100vh - 60px - 48px);
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: #f1f5f9;
}
</style>
